import { c as _c } from "react/compiler-runtime";
import { Hint, centsToUnits } from '@systemeio/ui';
import { pricePlanTypeLocoKeys } from 'modules/digital-product/price-plans/constants/price-plan-type-loco-keys';
import { PricePlanType, PricePlanTypeEnum } from '@systemeio/types';
import { taxBehaviorLocoKeys } from 'modules/payment/tax-behavior';
import React, { type JSX } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
interface PricePlanTooltipProps {
  pricePlan: PricePlanType;
  label: string | JSX.Element;
}
function PricePlanTooltip(t0) {
  const $ = _c(59);
  const {
    pricePlan,
    label
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.funnel.configuration.common.price_plan.name_label");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-text-primary font-bold">{t1}:{" "}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== pricePlan.name || $[5] !== t2) {
    t3 = <p className="text-start">{t2}{pricePlan.name}</p>;
    $[4] = pricePlan.name;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("dashboard.funnel.configuration.common.price_plan.statement_descriptor");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <span className="text-text-primary font-bold">{t4}:{" "}</span>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== pricePlan.statementDescriptor || $[12] !== t5) {
    t6 = <p className="text-start">{t5}{pricePlan.statementDescriptor}</p>;
    $[11] = pricePlan.statementDescriptor;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("dashboard.funnel.configuration.common.price_plan.type");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <span className="text-text-primary font-bold">{t7}:{" "}</span>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = pricePlanTypeLocoKeys[pricePlan.type];
  let t10;
  if ($[18] !== t || $[19] !== t9) {
    t10 = t(t9);
    $[18] = t;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t8) {
    t11 = <p className="text-start">{t8}{t10}</p>;
    $[21] = t10;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== pricePlan.recurringOptions || $[25] !== pricePlan.type || $[26] !== t) {
    t12 = pricePlan.type === PricePlanTypeEnum.limited_subscription && <p className="text-start"><span className="text-text-primary font-bold">{t("dashboard.funnel.configuration.common.price_plan.subscription_plan.limit_of_payments")}:{" "}</span>{pricePlan.recurringOptions.limitOfPayments}</p>;
    $[24] = pricePlan.recurringOptions;
    $[25] = pricePlan.type;
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== pricePlan.recurringOptions || $[29] !== t) {
    t13 = pricePlan.recurringOptions && pricePlan.recurringOptions.trialPeriod > 0 && <p className="text-start"><span className="text-text-primary font-bold">{`${t("dashboard.funnel.configuration.common.price_plan.subscription_plan.trial_period")} : `}</span>{t(`dashboard.funnel.configuration.common.price_plan.period.${pricePlan.recurringOptions.trialInterval}`, {
        count: pricePlan.recurringOptions.trialPeriod
      })}</p>;
    $[28] = pricePlan.recurringOptions;
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== pricePlan.amount || $[32] !== pricePlan.currency || $[33] !== pricePlan.recurringOptions || $[34] !== pricePlan.type || $[35] !== t || $[36] !== user?.dashboardLocale) {
    t14 = pricePlan.type === PricePlanTypeEnum.one_shot ? <p className="text-start"><span className="text-text-primary font-bold">{t("dashboard.funnel.configuration.common.price_plan.direct_charge_amount")}:{" "}</span>{`${currencyFormat(centsToUnits(pricePlan.amount), pricePlan.currency, user?.dashboardLocale)}`}</p> : <p className="text-start"><span className="text-text-primary font-bold">{t("dashboard.funnel.configuration.common.price_plan.direct_charge_amount")}:{" "}</span>{pricePlan.amount && `${currencyFormat(centsToUnits(pricePlan.amount), pricePlan.currency, user?.dashboardLocale)} ${t("dashboard.funnel.configuration.common.price_plan.subscription_plan.interval_label")} ${t(`dashboard.funnel.configuration.common.price_plan.period.${pricePlan.recurringOptions.interval}`, {
        count: pricePlan.recurringOptions.intervalCount
      })}`}</p>;
    $[31] = pricePlan.amount;
    $[32] = pricePlan.currency;
    $[33] = pricePlan.recurringOptions;
    $[34] = pricePlan.type;
    $[35] = t;
    $[36] = user?.dashboardLocale;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t) {
    t15 = t("dashboard.payment.tax_behavior.title");
    $[38] = t;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t15) {
    t16 = <span className="text-text-primary font-bold">{t15}:{" "}</span>;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  const t17 = taxBehaviorLocoKeys[pricePlan.taxBehavior];
  let t18;
  if ($[42] !== t || $[43] !== t17) {
    t18 = t(t17);
    $[42] = t;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t16 || $[46] !== t18) {
    t19 = <p className="text-start">{t16}{t18}</p>;
    $[45] = t16;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== t11 || $[49] !== t12 || $[50] !== t13 || $[51] !== t14 || $[52] !== t19 || $[53] !== t3 || $[54] !== t6) {
    t20 = <div className="font-inter flex flex-col items-start gap-2">{t3}{t6}{t11}{t12}{t13}{t14}{t19}</div>;
    $[48] = t11;
    $[49] = t12;
    $[50] = t13;
    $[51] = t14;
    $[52] = t19;
    $[53] = t3;
    $[54] = t6;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== label || $[57] !== t20) {
    t21 = <Hint mode="hover" label={t20}>{label}</Hint>;
    $[56] = label;
    $[57] = t20;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  return t21;
}
export default PricePlanTooltip;